import React from "react";
import appstore from "../assets/appstore.webp";
import googleplay from "../assets/googleplay.webp";

export default function AppPromoSection({
  titleStart = "Make the",
  highlight = "Plant-based Switch",
  description = "Get access to weekly guidance and materials, lesson plans, daily menus and curated recipes.",
  tagline = "",
  appStoreLink = "#",
  googlePlayLink = "#",
  desktopImage,
  mobileImage,
}) {
  return (
    <section className="relative overflow-hidden w-full bg-white">
      {/* ✅ Responsive image that adjusts naturally */}
      <picture>
        <source media="(max-width: 768px)" srcSet={mobileImage} />
        <img
          src={desktopImage}
          alt="App promo"
          loading="lazy"
          decoding="async"
          className="w-full h-auto object-cover"
        />
      </picture>

      {/* ✅ Overlay content */}
      {/* <div className="absolute inset-0 flex items-center"> */}
        <div className="absolute inset-0 flex flex-col items-start justify-start pt-12 px-4 sm:px-6 md:px-10 md:pt-0 md:items-center md:justify-center">
        <div className="max-w-7xl mx-auto px-4 w-full">
          <h2 className="text-4xl sm:text-5xl font-semibold text-gray-900 leading-snug mb-4">
            {titleStart}{" "}
            <span className="text-[#C03CA0] font-bold">{highlight}</span>
          </h2>

          <p className="text-gray-700 mb-5 leading-relaxed max-w-md">
            {description}
          </p>

          <p className="text-[#C03CA0] font-medium mb-6">{tagline}</p>

          <div className="flex items-center gap-3">
            <a href={appStoreLink} target="_blank" rel="noopener noreferrer">
              <img
                src={appstore}
                alt="Download on App Store"
                className="h-8 w-auto transition-transform hover:scale-105"
              />
            </a>
            <a href={googlePlayLink} target="_blank" rel="noopener noreferrer">
              <img
                src={googleplay}
                alt="Get it on Google Play"
                className="h-8 w-auto transition-transform hover:scale-105"
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
